import Vue from 'vue'
import Router from 'vue-router'
import legalService from '@/views/legalService'
import userService from '@/views/userService'
import ttfService from '@/views/ttfService'
import xjLegalService from '@/views/xjLegalService'
import xjMerchantService from '@/views/xjMerchantService'
import xjUserService from '@/views/xjUserService'
import ZJBankService from '@/views/ZJBankService'
import thirdSdkList from '@/views/thirdSdkList'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/legalService',
    },
    {
      path: '/legalService',
      name: 'legalService',
      component: legalService,
    },
    {
      path: '/userService',
      name: 'userService',
      component: userService,
    },
    {
      path: '/ttfService',
      name: 'ttfService',
      component: ttfService,
    },
    {
      path: '/xjLegalService',
      name: 'xjLegalService',
      component: xjLegalService,
    },
    {
      path: '/xjMerchantService',
      name: 'xjMerchantService',
      component: xjMerchantService,
    },
    {
      path: '/xjUserService',
      name: 'xjUserService',
      component: xjUserService,
    },
    {
      path: '/ZJBankService',
      name: 'ZJBankService',
      component: ZJBankService,
    },
    {
      path: '/thirdSdkList',
      name: 'thirdSdkList',
      component: thirdSdkList,
    },
  ],
})
